/**
 * Helpers para derivar o modo de validação a partir do contexto da tela.
 */

import type { ValidationMode } from './validators';

export interface ResolveValidationModeInput {
  isTempSaveFlow?: boolean;
  isQuotation?: boolean;
}

/**
 * Deriva o ValidationMode a partir do fluxo atual da OrderDetailsWindow.
 */
export const resolveValidationMode = ({
  isTempSaveFlow = false,
  isQuotation = false,
}: ResolveValidationModeInput): ValidationMode => {
  if (isTempSaveFlow) return 'temp-save';
  if (isQuotation) return 'quotation';
  return 'official-save';
};
